import React, { useState } from "react";
import { closeicon, erroricon } from "assets/icons/index";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useTranslation } from "react-i18next";
import { useGenerateOtpResetPasswordFormik } from "Forms/ResetPassword/generateOtpFormik";

interface GenerateOtpResetPasswordProps {
  activePop: string;
  setActivePop: React.Dispatch<React.SetStateAction<string>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setPhoneNum: React.Dispatch<React.SetStateAction<string>>;
  setCountryCode: React.Dispatch<React.SetStateAction<string>>;
  resetPasswordMethod: number;
}

const GenerateOtpResetPassword = ({
  activePop,
  setActivePop,
  resetPasswordMethod,
  setPhoneNum,
  setEmail,
  setCountryCode,
}: GenerateOtpResetPasswordProps) => {
  const { t, i18n } = useTranslation();
  const [country, setCountry] = useState("");

  const formik = useGenerateOtpResetPasswordFormik(
    resetPasswordMethod,
    country,
    setActivePop,
    setPhoneNum,
    setEmail,
    setCountryCode
  );

  const { generateOtpLoading } = useSelector(
    (state: RootState) => state.generateOtpResetPassword
  );

  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="400"
      className="fixed top-0 right-0 w-full h-screen bg-black/75 flex items-center justify-center z-10"
    >
      <div
        className={`relative lg:w-[410px] p-[30px] bg-white rounded-[15px] flex flex-col gap-[25px] text-second_color ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/*************************** top title section  **************/}
        <div className="relative flex items-center justify-between">
          <div></div>
          {/* Reset Password */}
          <div className="text-[24px] font-[700] text-second_color flex items-center justify-center">
            {t("Reset Password")}
          </div>

          {/* close button */}
          <div className="cursor-pointer" onClick={() => setActivePop("")}>
            <img src={closeicon} alt="logo" />
          </div>
        </div>

        {/*************************** instructions ***************************/}
        {resetPasswordMethod === 1 ? (
          <div className="text-[14px] font-[700] text-second_color flex items-center justify-center">
            {t("We will send a verification code to your phone")}
          </div>
        ) : (
          <div className="text-[14px] font-[700] text-second_color flex items-center justify-center">
            {t("We will send a verification code to your email")}
          </div>
        )}

        {/*************************** Phone number section  **************/}
        <form
          onSubmit={formik.handleSubmit}
          className="flex flex-col gap-[20px] text-second_color"
        >
          {resetPasswordMethod === 1 ? (
            //////////////////////////////////////////////  phone
            //  <Spin spinning={phoneOtpLoading}>
            <div className="flex flex-col gap-3">
              <div className="flex flex-col items-center gap-3">
                <PhoneInput
                  inputStyle={{
                    width: "100%",
                    height: "48px",
                    borderRadius: "10px",
                  }}
                  country={"ae"}
                  onlyCountries={["eg", "ae"]}
                  dropdownStyle={{
                    color: "black",
                  }}
                  countryCodeEditable={false}
                  // disabled={disapbleSendCode}
                  onChange={(phone, x, y, valueseparated) => {
                    // the country code
                    const countryCode = valueseparated.split(" ").shift();
                    formik.setFieldValue("countryCode", countryCode);

                    if (countryCode === "+20") {
                      setCountry("eg");
                    } else if (countryCode === "+971") {
                      setCountry("uae");
                    }
                    const countryCodeLength = countryCode
                      ?.split("")
                      .filter((item: any, idx: number) => idx !== 0)
                      .join("").length;

                    // phone number
                    const phoneNumber = phone.slice(
                      countryCodeLength,
                      phone.length
                    );

                    formik.setFieldValue("phone", phoneNumber);
                  }}
                />
                {/* errors section  */}
                <div className=" w-full flex items-center">
                  {formik.errors.phone && (
                    <p className="text-red-700 font-Avenir_demi text-[14px] flex items-center gap-1 animate-pulse">
                      <img className="w-[22px]" src={erroricon} alt="" />{" "}
                      {formik.errors.phone}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ///////////////////////////////////////////// email
            <div className="flex flex-col items-center gap-3">
              <div className="w-full flex items-center gap-3">
                <input
                  type="email"
                  placeholder={t("Email")}
                  name="email"
                  onChange={formik.handleChange}
                  className={`w-full h-[48px] rounded-[15px] bg-[#ddd9d9] border-white border-[1px]  placeholder-black focus:outline-none ${
                    i18n.language === "en" ? "pl-[15px]" : "pr-[15px]"
                  }`}
                  // readOnly={emailReadOnly}
                />
              </div>

              {/* errors section  */}
              <div className="mt-[-10px] w-full flex items-center">
                {formik.errors.email && (
                  <p className="text-red-700 font-Avenir_demi text-[14px] flex items-center gap-1 animate-pulse">
                    <img className="w-[22px]" src={erroricon} alt="" />{" "}
                    {formik.errors.email}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* </Spin> */}

          {/* next  button  */}
          <Spin spinning={generateOtpLoading}>
            <button
              type="submit"
              className="w-full h-[40px] bg-[#ddd9d9] text-second_color text-[14px] font-[700] rounded-[15px] hover:text-white hover:bg-first_color duration-300"
            >
              {t("Send Code")}
            </button>
          </Spin>
        </form>
      </div>
    </section>
  );
};

export default GenerateOtpResetPassword;
